(() => {
  const script = document.currentScript;
  const locale = script?.dataset.locale;
  const shop = script?.dataset.shop;
  const routes = { de: '/de-de/pages/reviews', it: '/it-it/pages/reviews', fr: '/fr-eu/pages/reviews', es: '/es-eu/pages/reviews', pl: '/pl-pl/pages/reviews' };
  if (!shop || location.pathname.replace(/\/$/, '') !== routes[locale] || script.dataset.country === 'US' || new URLSearchParams(location.search).get('view') === 'surge') return;
  const dictionary = new Map();
  const translatedNodes = new WeakMap();
  const knownReviews = new Set();
  let loadedPages = 0;
  let totalPages = Infinity;
  let running = false;
  let scheduled = false;
  let rerun = false;
  let failed = false;
  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim();
  const plain = value => new DOMParser().parseFromString(value || '', 'text/html').body.textContent;
  const body = review => review.body || plain(review.body_html);
  async function request(path, values) {
    const url = new URL(path, 'https://api.judge.me/');
    Object.entries({ ...values, shop_domain: shop, platform: 'shopify' }).forEach(([key, value]) => url.searchParams.set(key, value));
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error(`Judge.me ${response.status}`);
      return await response.json();
    } finally {
      clearTimeout(timeout);
    }
  }
  function remember(review, translated) {
    if (!translated?.body?.success || !translated.body.translated_text) return;
    const title = translated.title?.success ? translated.title.translated_text : review.title;
    const text = translated.body.translated_text;
    if (normalize(review.title)) dictionary.set(normalize(review.title), title);
    if (normalize(body(review))) dictionary.set(normalize(body(review)), text);
    if (normalize(review.title) && normalize(body(review))) dictionary.set(normalize(`${review.title} ${body(review)}`), `${title} ${text}`);
  }
  function apply() {
    document.querySelectorAll('.jdgm-reviews-grid-widget .jdgm-review-card').forEach(card => {
      const walker = document.createTreeWalker(card, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('.jdgm-review-card__footer, [class*="reviewer"], [class*="star-rating"], [class*="date"], button, script, style')) continue;
        const key = normalize(node.textContent);
        if (translatedNodes.get(node) === key || !dictionary.has(key)) continue;
        const value = dictionary.get(key);
        if (!value || normalize(value) === key) continue;
        translatedNodes.set(node, normalize(value));
        node.textContent = value;
      }
    });
  }
  async function loadPage(page) {
    const payload = await request('widgets/reviews_grid_widget_data', { review_selection: 'all', display_order: 'media_first', page, per_page: 24 });
    const reviews = (payload.reviews || []).filter(review => review.uuid && !knownReviews.has(review.uuid));
    totalPages = payload.total_pages || 1;
    if (reviews.length) {
      const translated = await request('api/review_translations', { review_uuids: reviews.map(review => review.uuid).join(','), language: locale, page: -1 });
      reviews.forEach(review => {
        remember(review, translated[review.uuid]);
        knownReviews.add(review.uuid);
      });
    }
    loadedPages = page;
  }
  async function run() {
    scheduled = false;
    if (running) { rerun = true; return; }
    if (failed) return;
    running = true;
    try {
      const cards = document.querySelectorAll('.jdgm-reviews-grid-widget .jdgm-review-card').length;
      if (!cards) return;
      const required = Math.max(1, Math.ceil(cards / 24));
      while (loadedPages < Math.min(required, totalPages)) {
        await loadPage(loadedPages + 1);
        apply();
      }
      apply();
    } catch (error) {
      failed = true;
      console.info('Local review translations are temporarily unavailable.', error.message);
    } finally {
      running = false;
      if (rerun) { rerun = false; schedule(); }
    }
  }
  function schedule() {
    if (scheduled || failed) return;
    scheduled = true;
    setTimeout(run, 120);
  }
  const observer = new MutationObserver(schedule);
  function start() {
    const root = document.querySelector('#MainContent');
    if (!root) return;
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
